import { connect } from 'react-redux';
import { resetPassword } from '../reducers/auth.reducers';
import ResetPassword from './resetpassword';

const mapDispatchToProps = dispatch => ({
  resetPassword: credentials => dispatch(resetPassword(credentials)),
});

const mapStateToProps = state => ({
  errorMessage: state.authentication.errorMessage,
  loading: state.authentication.loading,
});

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);



// WEBPACK FOOTER //
// ./src/app/resetpassword/resetpassword.container.js